import React, {useState, useEffect} from 'react';
import Card from 'react-bootstrap/Card';
import {Form} from 'react-bootstrap';
export default function StepCondition(props) {
  return (
    <div className="row">
      <Form.Group className="mb-3 col-md-12">
        <Form.Control
          disabled
          as="textarea"
          rows="5"
          value={`1. สามารถโยกงบได้ในปีงบประมาณปัจจุบัน เท่านั้น\n2. สามารถโยกงบได้ภายในปีงบปัจจุบัน เท่านั้น (ขั้นทดสอบ)\n3. งบที่โยกได้จะเป็นมูลค่าหลักร้อย เช่นคงเหลือ 1,234 บาท จะโยกได้ 1,200 บาท\n4. เดือนปลายทางที่รับโยกงบต้องเป็นเดือนปัจจุบันและเดือนถัดๆ ไป เท่านั้น\n5. ลำดับการอนุมัติคือ ibc และ cr ตามลำดับ`}
        />
      </Form.Group>
    </div>
  );
}
